export const themeColor = {
    main: "#222",
    main2: "#111",
    main3: "#303030",
    text_title: "linear-gradient(45deg,  #ffffff,#3e3e3e)",

}